import { connect } from 'react-redux';
import { OrganizationState } from '@piwikpro/organization-crate';
import { AuditLogState } from '@piwikpro/audit-log-crate/reducer';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import EditAuditLogRetentionModal from './EditAuditLogRetentionModal';

interface State {
  auditLogDataRetention: AuditLogState['retention']['details']
  instanceAddress: SessionState['instanceAddress']
  license: OrganizationState['details']['license']['current']
}

const mapStateToProps = state => ({
  license: state.organization.details.license?.current,
  instanceAddress: state.session.instanceAddress,
  auditLogDataRetention: state.auditLog.retention.details,
});

export default connect<
State,
null,
{ onClose:() => void }>(mapStateToProps)(EditAuditLogRetentionModal);
